(function () {
  if (window.__rvPacks) { window.__rvPacks.init(); return; }
  var MODELS = [
    { id: 58192299131262, name: 'Flor rosa', short: 'Flor', icon: '🌸' },
    { id: 58192299164030, name: 'Mariposa azul', short: 'Mariposa', icon: '🦋' },
    { id: 58192299196798, name: 'Ojo turco', short: 'Ojo turco', icon: '🧿' }
  ];
  var GIFT_IMG = 'https://cdn.shopify.com/s/files/1/1026/5074/1118/files/Roossiva_ebook_regalo.jpg?v=1791803335&width=200';
  var PACKS = [
    { qty: 1, name: '1 anillo', sub: 'Tu anillo antiestrés', now: '19,99 €', was: '39,98 €', def: [0] },
    { qty: 2, name: 'Pack 2 anillos', sub: '15,00 € por anillo', save: 'Ahorras 9,99 €', now: '29,99 €', was: '39,98 €', def: [0, 1] },
    { qty: 3, name: 'Pack 3 anillos', sub: '13,33 € por anillo', save: 'Ahorras 19,98 €', now: '39,99 €', was: '59,97 €', badge: 'MÁS VENDIDO', gift: true, def: [0, 1, 2] }
  ];

  function scopeOf(el) { return el.closest('product-info') || el.closest('section') || document; }

  function syncImage(scope, modelIdx) {
    var name = MODELS[modelIdx].name;
    var input = scope.querySelector('variant-selects input[value="' + name + '"], variant-radios input[value="' + name + '"]');
    if (input && !input.checked) { input.click(); return; }
    var sel = scope.querySelector('variant-selects select, variant-radios select');
    if (sel) { sel.value = name; sel.dispatchEvent(new Event('change', { bubbles: true })); }
  }

  function build(box) {
    var scope = scopeOf(box);
    if (scope.classList) scope.classList.add('rv-scope');
    if (!document.getElementById('rv-packs')) box.id = 'rv-packs';
    var defQty = parseInt(box.getAttribute('data-default') || '3', 10);
    var defIdx = 0; PACKS.forEach(function (p, i) { if (p.qty === defQty) defIdx = i; });
    var state = { active: defIdx, picks: PACKS.map(function (p) { return p.def.slice(); }) };
    box.innerHTML = '';
    var title = document.createElement('p'); title.className = 'rv-packs__title'; title.textContent = 'Elige tu pack'; box.appendChild(title);

    PACKS.forEach(function (p, pi) {
      var card = document.createElement('div');
      card.className = 'rv-pack'; card.setAttribute('role', 'button'); card.setAttribute('tabindex', '0');
      card.innerHTML =
        (p.badge ? '<span class="rv-pack__badge">' + p.badge + '</span>' : '') +
        '<div class="rv-pack__head"><span class="rv-pack__radio"></span>' +
        '<div class="rv-pack__main"><div class="rv-pack__name">' + p.name + '</div><div class="rv-pack__sub">' + p.sub + '</div>' +
        (p.save ? '<span class="rv-pack__save">' + p.save + '</span>' : '') + '</div>' +
        '<div class="rv-pack__price"><div class="rv-pack__now">' + p.now + '</div><div class="rv-pack__was">' + p.was + '</div></div></div>' +
        (p.gift ? '<div class="rv-pack__gift"><img src="' + GIFT_IMG + '" alt="" width="44" height="44" loading="lazy"><div><b>🎁 + Ebook de regalo</b><span>«Tu pequeño ritual de calma»</span></div></div>' : '') +
        '<div class="rv-pack__rings"></div>';
      var rings = card.querySelector('.rv-pack__rings');
      for (var r = 0; r < p.qty; r++) {
        var row = document.createElement('div'); row.className = 'rv-ring';
        row.innerHTML = '<span class="rv-ring__label">' + (p.qty > 1 ? 'Anillo ' + (r + 1) : 'Modelo') + '</span><div class="rv-ring__opts"></div>';
        var opts = row.querySelector('.rv-ring__opts');
        MODELS.forEach(function (m, mi) {
          var b = document.createElement('button'); b.type = 'button'; b.className = 'rv-opt';
          b.setAttribute('data-ring', r); b.setAttribute('data-model', mi);
          b.innerHTML = '<span>' + m.icon + '</span> ' + m.short;
          opts.appendChild(b);
        });
        rings.appendChild(row);
      }
      card.addEventListener('click', function (e) {
        var opt = e.target.closest('.rv-opt');
        if (opt) {
          e.stopPropagation();
          var ring = +opt.getAttribute('data-ring'), mi = +opt.getAttribute('data-model');
          state.picks[pi][ring] = mi; state.active = pi; render();
          if (ring === 0) syncImage(scope, mi);
          return;
        }
        if (state.active !== pi) { state.active = pi; render(); syncImage(scope, state.picks[pi][0]); }
      });
      card.addEventListener('keydown', function (e) { if ((e.key === 'Enter' || e.key === ' ') && e.target === card) { e.preventDefault(); card.click(); } });
      box.appendChild(card);
    });

    var note = document.createElement('p'); note.className = 'rv-packs__note';
    note.textContent = 'Puedes combinar los modelos que quieras dentro del pack.'; box.appendChild(note);

    function render() {
      box.querySelectorAll('.rv-pack').forEach(function (card, pi) {
        card.classList.toggle('is-active', pi === state.active);
        card.querySelectorAll('.rv-opt').forEach(function (o) {
          o.classList.toggle('is-on', state.picks[pi][+o.getAttribute('data-ring')] === +o.getAttribute('data-model'));
        });
      });
    }
    render();
    box.__rvState = state;
    box.__rvItems = function () {
      var counts = {};
      state.picks[state.active].forEach(function (mi) { var id = MODELS[mi].id; counts[id] = (counts[id] || 0) + 1; });
      return Object.keys(counts).map(function (id) { return { id: +id, quantity: counts[id] }; });
    };
    box.setAttribute('data-ready', '1');
  }

  function addToCart(box, btn) {
    if (box.__rvBusy) return; box.__rvBusy = true;
    var cart = document.querySelector('cart-drawer') || document.querySelector('cart-notification');
    var label = btn ? btn.querySelector('span') : null, old = label ? label.textContent : '';
    var spinner = btn ? btn.querySelector('.loading__spinner') : null;
    if (btn) { btn.setAttribute('aria-disabled', 'true'); btn.classList.add('loading'); }
    if (spinner) spinner.classList.remove('hidden');
    var addUrl = (window.routes && window.routes.cart_add_url) ? window.routes.cart_add_url : '/cart/add';
    var cartUrl = (window.routes && window.routes.cart_url) ? window.routes.cart_url : '/cart';
    var body = { items: box.__rvItems() };
    if (cart) { body.sections = 'cart-drawer,cart-icon-bubble'; body.sections_url = window.location.pathname; }
    function done() {
      box.__rvBusy = false;
      if (btn) { btn.removeAttribute('aria-disabled'); btn.classList.remove('loading'); }
      if (spinner) spinner.classList.add('hidden');
      if (label) label.textContent = old;
    }
    fetch(addUrl + '.js', { method: 'POST', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json', 'X-Requested-With': 'XMLHttpRequest' }, body: JSON.stringify(body) })
      .then(function (r) { return r.json(); })
      .then(function (res) {
        if (res && res.status && res.status !== 200) throw new Error(res.description || 'add');
        if (!cart || !res.sections || !res.sections['cart-drawer']) { window.location.href = cartUrl; return; }
        try {
          var bubble = document.getElementById('cart-icon-bubble');
          if (bubble && res.sections['cart-icon-bubble']) {
            var d = new DOMParser().parseFromString(res.sections['cart-icon-bubble'], 'text/html');
            var inner = d.querySelector('.shopify-section') || d.body;
            bubble.innerHTML = inner.innerHTML;
          }
        } catch (e) {}
        cart.classList.remove('is-empty');
        if (typeof cart.setActiveElement === 'function' && btn) cart.setActiveElement(btn);
        try { cart.renderContents(res); }
        catch (e) { window.location.href = cartUrl; return; }
        cart.classList.remove('is-empty');
      })
      .catch(function () { window.location.href = cartUrl; })
      .finally(done);
  }

  function boxFor(el) {
    var found = null;
    document.querySelectorAll('.rv-packs[data-ready]').forEach(function (b) {
      var s = scopeOf(b);
      if (s.contains(el) || (el.id && s.querySelector('[form="' + el.id + '"]'))) found = b;
    });
    return found;
  }

  document.addEventListener('click', function (e) {
    var btn = e.target.closest && e.target.closest('button[name="add"], .product-form__submit');
    if (!btn) return;
    var box = boxFor(btn); if (!box) return;
    e.preventDefault(); e.stopImmediatePropagation();
    addToCart(box, btn);
  }, true);

  document.addEventListener('submit', function (e) {
    var box = boxFor(e.target); if (!box) return;
    e.preventDefault(); e.stopImmediatePropagation();
    addToCart(box, e.target.querySelector('button[name="add"], .product-form__submit'));
  }, true);

  function init() { document.querySelectorAll('.rv-packs:not([data-ready])').forEach(build); }
  window.__rvPacks = { init: init };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
  document.addEventListener('shopify:section:load', init);
})();
